export const CPR_REQUEST_VALIDATION_RULES = {
    rights: {presence: {allowEmpty: false}, length: {minimum: 1}},
    description: {length: {maximum: 3000}},
    california_resident: {presence: {allowEmpty: false}},
    penalty_of_perjury: {presence: {allowEmpty: false}},
    termination_acknowledgment: {presence: {allowEmpty: false}},
    identity_verification: {presence: {allowEmpty: false}},
};
